import { apiPost } from './client';

export async function sendChatMessage(message, conversationId) {
  return apiPost('/chat', { message, conversationId });
}
